<template>
    <div class="popupBg" @click.self="pressDone">
        <div class="popupArea bg-lightest px-3 d-flex flex-column justify-content-between">
            <div>
                <transport-extras-selector :reservation="getSelectedReservation"></transport-extras-selector>

                <div class="text-center" v-if="!routes">
                    <loader></loader>
                </div>

                <transport-editor :transfer="getSelectedReservation.transport.transfers[0]" :routes="routes" :reservation="getSelectedReservation" title="Pick up location" :type="1"></transport-editor>
            </div>
            
            <div class="mt-2 mb-3 text-right pos-rel">
                <button class="btn primary wider ml-2"  @click="pressDone">Done</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reservationsMixin } from '@/mixins/reservations';
import extendedVSelect from '@/extends/vue-select';

import TransportEditor from '@/components/reservations/NewReservation/Resume/AddTransport/RouteForm';
import TransportExtrasSelector from '@/components/reservations/NewReservation/Resume/AddTransport/AddExtraTransport';
import Loader from '@/tools/loaders/loader1';

export default {
    data: function() {
        return {
            routes: null,
        }
    },
    created: function () {
        this.routes = this.getAllRoutes;
    },
    computed: {
        ...mapGetters([
            'account',
            'getSelectedReservation',
            'getAllRoutes'
        ])
    },
    mixins:[
        reservationsMixin
    ],
    methods: {
        pressDone: function() {
            this.eventHub.$emit('editReservation_toggleEditTransport');
        },
    },
    components: {
        vSelect: extendedVSelect,
        TransportEditor,
        Loader,
        TransportExtrasSelector,
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .paymentRowsHolder {
        max-height: 200px;
        overflow: auto;

        div:nth-child(odd) {
            background-color: $lighter;
        }
    }

    .payMethod {
        width: 103px;
        height: 72px;

        &.selected {
            border-color: $darkest !important;
            border-width: 2px !important;
        }

        &:hover {
            background-color: $lighter;
        }
    }

    .popupBg {
        background-color: rgba(0,0,0,0.5);
        width: 100%;
        height: 100%;
        z-index: 10;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;

        .popupArea {
            width: 94%;
            height: 90%;
            max-height: 100%;
            margin: 0 auto;
            overflow: auto;
        }
    }

    .pos-rel {
        position: relative;
        right: 20px;
        bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// EditTransport.vue?68a1441d